import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from 'apollo-client';

import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';

type ConsumerBffCourseContextType =
  | {
      coursePage?: ConsumerCoursePageFieldsFragment | null | undefined;
      isCourseDataLoading?: boolean;
      error?: ApolloError;
    }
  | undefined;

const ConsumerBffCourseContext = React.createContext<ConsumerBffCourseContextType>(undefined);

export const useCoursePageData = () => {
  const context = useContext(ConsumerBffCourseContext);

  return context?.coursePage;
};

export const useIsCourseDataLoading = () => {
  const context = useContext(ConsumerBffCourseContext);

  return context?.isCourseDataLoading;
};

export const useCoursePageError = () => {
  const context = useContext(ConsumerBffCourseContext);

  return context?.error;
};

export default ConsumerBffCourseContext;
